module.exports = __webpack_public_path__ + "static/img/01.60b188e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/01.jpg
// module id = ja9r
// module chunks = 0